import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";

function Footer() {
  return (
    <footer className="relative bg-[#333333] text-white">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:60px_60px]"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#D82F2F]/10 via-transparent to-transparent"></div>
      </div>

      {/* Main Footer Content */}
      <div className="relative">
        <div className="container mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <div className="relative group">
                  <div className="absolute -inset-1 rounded-lg bg-gradient-to-r from-[#D82F2F] to-[#D82F2F] opacity-70 blur"></div>
                  <div className="relative p-1 bg-[#333333] rounded-lg">
                    <img
                      src={Logo}
                      alt="Triveni Industrial Gases Logo"
                      className="w-16 h-16 object-contain"
                    />
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold">
                    <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-[#D82F2F] to-[#D82F2F]">
                      Triveni
                    </span>
                  </h3>
                  <p className="text-white/80 text-sm">Industrial Gases</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-[#D82F2F]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <div className="text-sm text-white/80">
                    <a href="tel:+918299204736" className="hover:text-[#D82F2F] transition-colors duration-300">+91 8299204736</a>
                    <span className="mx-2">|</span>
                    <a href="tel:+919119117385" className="hover:text-[#D82F2F] transition-colors duration-300">+91 9119117385</a>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-[#D82F2F]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <a href="mailto:trivenigases10@gmail.com" className="text-sm text-white/80 hover:text-[#D82F2F] transition-colors duration-300">
                    trivenigases10@gmail.com
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-white relative">
                Quick Links
                <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#D82F2F]"></span>
              </h3>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300">Home</Link>
                </li>
                <li>
                  <Link to="/about" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300">About Us</Link>
                </li>
                <li>
                  <Link to="/products/welding-materials" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300">Products</Link>
                </li>
                <li>
                  <Link to="/contact" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300">Contact Us</Link>
                </li>
              </ul>
            </div>

            {/* Products */}
            <div className="col-span-2">
              <h3 className="text-lg font-semibold mb-6 text-white relative">
                Our Products
                <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#D82F2F]"></span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <div className="mb-6">
                    <h4 className="text-[#D82F2F] font-medium mb-3">Welding Materials</h4>
                    <ul className="space-y-2">
                      <li>
                        <Link to="/products/welding-materials" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Welding electrodes, Filter wires, TIG welding
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/welding-materials" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Welding machines, Holders & Cables
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/welding-materials" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Safety Equipment & Accessories
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-[#D82F2F] font-medium mb-3">Industrial Gas Cylinders</h4>
                    <ul className="space-y-2">
                      <li>
                        <Link to="/products/gas-cylinders" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Oxygen & Nitrogen Cylinders
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/gas-cylinders" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Hydrogen & Argon Cylinders
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/gas-cylinders" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          CO2 & Acetylene Cylinders
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div>
                  <div className="mb-6">
                    <h4 className="text-[#D82F2F] font-medium mb-3">Ropes & Safety Equipment</h4>
                    <ul className="space-y-2">
                      <li>
                        <Link to="/products/ropes-clamps" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          PP Ropes & Wire Rope Slings
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/ropes-clamps" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Clamps, Shackles & Chain Pulleys
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-[#D82F2F] font-medium mb-3">Personal Protective Equipment</h4>
                    <ul className="space-y-2">
                      <li>
                        <Link to="/products/ppe" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Head & Eye Protection
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/ppe" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Hand & Foot Protection
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-[#D82F2F] font-medium mb-3">Road & Fire Safety</h4>
                    <ul className="space-y-2">
                      <li>
                        <Link to="/products/safety" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Fire Extinguishers & Equipment
                        </Link>
                      </li>
                      <li>
                        <Link to="/products/safety" className="text-white/80 hover:text-[#D82F2F] transition-colors duration-300 text-sm">
                          Road Safety & Emergency Kits
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Certification */}
            <div>
              <h3 className="text-lg font-semibold mb-6 text-white relative">
                Certification
                <span className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#D82F2F]"></span>
              </h3>
              <div className="bg-[#333333]/50 p-6 rounded-lg border border-[#D82F2F]/20">
                <div className="flex items-center space-x-3 mb-4">
                  <svg className="w-6 h-6 text-[#D82F2F]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span className="text-white font-medium">ISO 9001:2015</span>
                </div>
                <p className="text-sm text-white/70">
                  Certified for Quality Management System, ensuring highest standards in welding materials and gas solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="relative border-t border-[#D82F2F]/20">
          <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#D82F2F] to-transparent"></div>
          <div className="container mx-auto px-6 py-4">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-white/60 text-sm">
                © {new Date().getFullYear()} Triveni Industrial Gases. All rights reserved.
              </p>
              <div className="flex items-center space-x-2 mt-4 md:mt-0">
                <span className="text-white/60 text-sm">Innovating Gas Solutions Since 1990</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
